// extracted by mini-css-extract-plugin
export default {"warning":"Footer_warning__wcTsp","info":"Footer_info__9IMh8","arrowIcon":"Footer_arrowIcon__BuAf1"};